import React from 'react';
import { motion } from 'framer-motion';
import { techStack } from '../data/mock';

const ServiceTechnologies = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0, scale: 0.8 },
    visible: {
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 100
      }
    }
  };

  return (
    <section className="py-20 lg:py-24 bg-gray-50 overflow-hidden">
      <div className="container mx-auto px-4">
        <motion.div 
          className="text-center max-w-3xl mx-auto mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-block px-4 py-1 rounded-full bg-blue-100 text-blue-900 font-medium text-sm mb-4">
            Tech Stack
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
            Technologies We Master
          </h2>
          <p className="text-lg text-gray-600">
             We leverage best-in-class tools and frameworks to deliver superior results.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {techStack.map((category, idx) => (
            <motion.div
              key={idx}
              className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-md transition-shadow"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
            >
              <h3 className="text-xl font-bold text-gray-900 mb-6 border-b border-gray-100 pb-4">
                {category.category}
              </h3>
              <motion.div 
                className="grid grid-cols-4 gap-4"
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                {category.items.map((tech, i) => (
                  <motion.div 
                    key={i} 
                    variants={itemVariants}
                    className="flex flex-col items-center justify-center group"
                  >
                    <motion.div 
                      whileHover={{ scale: 1.1, rotate: 5 }}
                      className="w-12 h-12 flex items-center justify-center p-2 bg-gray-50 rounded-xl group-hover:bg-blue-50 transition-colors"
                    >
                      <img src={tech.icon} alt={tech.name} className="w-full h-full object-contain" />
                    </motion.div>
                    <span className="text-xs text-gray-500 mt-2 text-center group-hover:text-blue-600 transition-colors">
                      {tech.name}
                    </span>
                  </motion.div>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceTechnologies;
